import EA from 'helpers/init';
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';

export default EA.Methods.testimonialSlider = ($this) => {
    const slider = $this.querySelector('.swiper');
    const prev = $this.querySelector('.prev');
    const next = $this.querySelector('.next');
    const pagination = $this.querySelector('.swiper-pagination');

    new Swiper(slider, {
        modules: [Autoplay, EffectFade, Navigation, Pagination],
        speed: 1200,
        spaceBetween: 0,
        slidesPerView: 1,
        allowTouchMove: true,
        loop: true,
        effect: 'fade',
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        fadeEffect: {
            crossFade: true,
        },
        navigation: {
            prevEl: prev,
            nextEl: next
        },
        pagination: {
            el: pagination,
            type: 'bullets',
        },
    });
};
